import React from 'react';
import { useAuth } from 'context/auth';
import styles from './styles.module.css';
import { ActionBlockButton } from 'components/action-block';
import { Analytics } from 'constants/analytics';
import { useMemo } from 'react';
import { useMeQuery } from 'hooks/api/users';
import { ICasino } from 'constants/types';
import { useFavorites } from 'hooks/useFavorites';
import { saveRedirectOptions } from 'utils/redirectOptions';
import { Routes } from 'constants/routes';
import { getItemIdentifier } from 'utils/slug';
import { useLoginModal, useRedirectActions } from 'hooks';
import { RedirectActions } from 'constants/redirect-actions';
import { LoginModal } from 'components/modal/login';

export const CasinoNotification = ({ data }: { data: ICasino }) => {
  const { data: { user } = {}, isFetching: isUserFetching } = useMeQuery();
  const { addToFavorite, removeFromFavorite, isLoading } = useFavorites();
  const { isLoggedIn } = useAuth();
  const {
    handleCloseLoginModal,
    handleConfirmLoginModal,
    handleVisibleLoginModal,
    isLoginVisible,
  } = useLoginModal();
  useRedirectActions({
    actions: [
      {
        name: RedirectActions.Favorite,
        action: () => addToFavorite({ casinoId: data?._id }),
      },
    ],
  });
  const isFavorite = useMemo(() => {
    if (
      user?.favorite_casinos?.find((item) => item._id === data?._id) &&
      user?.favorite_casinos?.length
    ) {
      return true;
    }

    return false;
  }, [data?._id, user]);

  const onFavoriteText = useMemo(() => {
    if (isLoading || isUserFetching) {
      return 'Loading...';
    }
    if (isFavorite) {
      return 'Remove';
    } else {
      return 'Subscribe';
    }
  }, [isFavorite, isLoading, isUserFetching]);

  if (data?.RTP < 92 || data?.isClosed) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.iconContainer}>
          <div className={styles.icon} />
        </div>
        <div className={styles.textContainer}>
          <h3 className={styles.title}>
            Get instant notification about this casino
          </h3>
          <p className={styles.description}>
            RTP for Colt Lightning dropped to 93.5% — be careful in this slot
          </p>
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.subscribeButton}>
        <ActionBlockButton
          className={styles.notificationSubscribe}
          data={[
            {
              id: isFavorite ? Analytics.casino.unsave : Analytics.casino.save,
              anchorId: 0,
              text: onFavoriteText,
              icon: isFavorite ? 'remove' : 'save',
              onClick: async () => {
                if (isLoggedIn) {
                  if (isFavorite) {
                    await removeFromFavorite({ favoriteId: data?._id });
                  } else {
                    await addToFavorite({ casinoId: data?._id });
                  }
                } else {
                  saveRedirectOptions({
                    url: Routes.casinoPage(getItemIdentifier(data)),
                    action: RedirectActions.Favorite,
                  });
                  handleVisibleLoginModal();
                }
              },
            },
          ]}
        />
      </div>
      <div className={styles.notificationIcon} />
      <LoginModal
        isVisible={isLoginVisible}
        onClose={handleCloseLoginModal}
        confirmOnClick={handleConfirmLoginModal}
      />
    </div>
  );
};
